import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ClientDepartment, ClientLocation, Group, UserSegment } from 'api';

type TitleItem = ClientDepartment | ClientLocation | Group;

interface IProps {
  segment: UserSegment;
  title: string;
  listKey: keyof UserSegment;
}

const useStyles = makeStyles(theme => ({
  spacer: {
    marginRight: theme.spacing(0.5),
  },
}));

const Names: FC<IProps> = ({ title, listKey, segment }) => {
  const classes = useStyles();
  const list = segment[listKey] as TitleItem[];

  if (!list || (list && !list.length)) {
    return null;
  }

  const text = list.map((item: TitleItem) => item.title).join(', ');

  return (
    <Grid item>
      <Typography className={classes.spacer} display="inline">
        {title}:
      </Typography>
      <Typography display="inline" color="textSecondary">
        {text}
      </Typography>
    </Grid>
  );
};

export default Names;
